import { ObjectValues, SelectHtmlProps } from '../types';

import { SelectOption } from '../select-option/select-option.types';

export const labelPositions = {
  inline: 'inline',
  stacked: 'stacked',
} as const;

export const variants = {
  small: 'small',
  large: 'large',
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Select<OptionExtra = any> = {
  id: string;
  isLabelVisible?: boolean;
  label?: string;
  labelPosition?: ObjectValues<typeof labelPositions>;
  name: string;
  onChangeOption?: (option?: SelectOption<OptionExtra>) => void;
  options?: SelectOption<OptionExtra>[];
  variant?: ObjectValues<typeof variants>;
  wide?: boolean;
} & SelectHtmlProps;
